import { vraiFauxMigrator } from './scripts/vrai-faux.migrator';
import { Game } from '../game';
import { languagesFrEnMigrator } from './scripts/languages-fr-en.migrator';
import { addCustomGraphicFieldMigrator } from './scripts/custom-graphic-field.migrator';

export const GAME_CONFIG_MIGRATION = [
  {
    from: '1.0.0',
    to: '1.1.0',
    function: vraiFauxMigrator,
    type: Game.VRAI_FAUX,
  },
  {
    from: '1.1.0',
    to: '1.2.0',
    function: languagesFrEnMigrator,
  },
  {
    from: '1.2.0',
    to: '1.3.0',
    function: addCustomGraphicFieldMigrator,
  },
  {
    from: '1.3.0',
    to: '1.4.0',
    function: languagesFrEnMigrator,
  },
];

export const GAMES_LATEST_VERSION = GAME_CONFIG_MIGRATION[GAME_CONFIG_MIGRATION.length - 1].to;
